import * as React from 'react';
import { useField } from 'formik';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { hasValue } from './inputHelpers';

interface IProps {
  name: string
}

const XTextAreaInput = ({ name, onChange, ...props }: TextFieldProps & IProps) => {
  const [field, meta] = useField({ name });
  const error = hasValue(meta.error) ? meta.error : undefined;
  const showError = Boolean(error && meta.touched);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(event);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <TextField
      {...field}
      {...props}
      fullWidth
      error={showError}
      helperText={showError && error}
      value={field.value || ''}
      multiline
      maxRows="4"
      rows={4}
      autoComplete="off"
      onChange={handleChange}
    />
  );
};

export default XTextAreaInput;
